import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { 
	sendNewEmailMessage as sendNewEmailMessageApi, 
} from '../../helpers/message/backend_helper';

export const sendNewEmailMessage = createAsyncThunk('messages/sendNewEmailMessage', async (message) => {
	try {
		const response = await sendNewEmailMessageApi(message);  // Añade await aquí
		toast.success('Mensaje enviado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al enviar el mensaje.', { autoClose: 3000 });
		throw new Error(error);
	}
});

